export default {
    pageName: 'สร้างผู้เยี่ยมเยือน',
    profile: {
        name: 'ข้อมูล',
        detail: 'ขนาดภาพต้องอยู่ระหว่าง 25KB และ 200KB'
    },
    accessInfo: 'ข้อมูลการเข้าออก',
    setupDetail: 'ตั้งค่าเวลาต่อ 1 วัน',
    passportId: {
        title: 'บัตรประชาชน / หนังสือเดินทาง',
        placeholder: 'ระบุบัตรประชาชน / หนังสือเดินทาง'
    },
    name: {
        title: 'ชื่อ',
        placeholder: 'ระบุชื่อผู้เยี่ยมเยือน',
        require: 'กรุณากรอกชื่อ'
    },
    surname: {
        title: 'นามสกุล',
        placeholder: 'ระบุนามสกุล',
        require: 'กรุณากรอกนามสกุล'
    },
    gender: {
        title: 'เพศ',
        male: 'ชาย',
        female: 'หญิง'
    },
    visitAt: {
        title: 'เยี่ยมที่สำนักงาน',
        placeholder: '- เลือกสำนักงาน -',
        require: 'กรุณาเลือกสำนักงาน'
    },
    email: {
        title: 'อีเมล',
        placeholder: 'ระบุอีเมล',
        invalid: 'อีเมลไม่ถูกต้อง',
        require: 'กรุณากรอกอีเมล์'
    },
    phone: {
        title: 'เบอร์โทรศัพท์',
        placeholder: ' 00 000 0000',
        invalid: 'เบอร์โทรศัพท์ไม่ถูกต้อง',
        require: 'กรุณากรอกเบอร์โทรศัพท์'
    },
    operator: {
        title: 'บุคคลที่มาเข้าพบ',
        placeholder: 'ค้นหารหัสพนักงาน',
        require: 'กรุณากรอกบุคคลที่มาเข้าพบ',
        detail: 'ระบุรหัสพนักงานที่ดูแลเพื่อส่งการแจ้งเตือน (ผ่าน Line) เมื่อผู้เยี่ยมเยือนมาถึงสำนักงาน',
        btnClose: 'ปิด'
    },
    uploadIdCard: {
        title: 'อัปโหลดบัตรประชาชน',
        placeholder: 'JPG หรือ PNG ขนาดสูงสุด 10 MB',
        require: 'กรุณาอัปโหลดบัตรประชาชน'
    },
    startTime: {
        title: 'เวลาเริ่ม',
        placeholder: '- - : - -',
        require: 'กรุณากรอกเวลาเริ่ม'
    },
    endTime: {
        title: 'เวลาสิ้นสุด',
        placeholder: '- - : - -',
        require: 'กรุณากรอกเวลาสิ้นสุด'
    },
    button: {
        cancel: 'ยกเลิก',
        submit: 'ส่งข้อมูล'
    },
    modalFail: {
        btnOk: 'ปิด',
        titleFail: 'ขออภัย ไม่สามารถดำเนินการได้',
        title: 'แจ้งเตือน',
        body: 'ไม่พบข้อมูลบุคคลที่มาเข้าพบรหัส ',
        bodyFile: 'ขนาดภาพต้องอยู่ระหว่าง 25KB และ 200KB'
    },
    modalSuccess: {
        title: 'ส่งข้อมูลสำเร็จ',
        body: 'ส่งคำร้องสำเร็จ',
        btnOk: 'ยืนยัน'
    },
    idNumber: {
        titile: 'หมายเลขบัตรประชาชน',
        require: 'กรุณากรอกบัตรประชาชน/หนังสือเดินทาง'
    }
}
